__turbopack_context__.v({
  "copyright": "health100-footer-module-scss-module__viLWeG__copyright",
  "dialog": "health100-footer-module-scss-module__viLWeG__dialog",
  "dialogBody": "health100-footer-module-scss-module__viLWeG__dialogBody",
  "dialogClose": "health100-footer-module-scss-module__viLWeG__dialogClose",
  "dialogContainer": "health100-footer-module-scss-module__viLWeG__dialogContainer",
  "dialogHeader": "health100-footer-module-scss-module__viLWeG__dialogHeader",
  "dialogSizeMedium": "health100-footer-module-scss-module__viLWeG__dialogSizeMedium",
  "dialogTitle": "health100-footer-module-scss-module__viLWeG__dialogTitle",
  "footer": "health100-footer-module-scss-module__viLWeG__footer",
  "nav": "health100-footer-module-scss-module__viLWeG__nav",
  "navLink": "health100-footer-module-scss-module__viLWeG__navLink",
});
